import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Label2 } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { Wrench, CaretRight, Buildings, User } from "@phosphor-icons/react";

const JOB_TONE = { geplant:"border-blue-500/40 bg-blue-500/10 text-blue-600", laufend:"border-amber-500/40 bg-amber-500/10 text-amber-600", abgeschlossen:"border-emerald-500/40 bg-emerald-500/10 text-emerald-600" };

export default function Wartungsauftraege() {
  const [jobs, setJobs] = useState(null);
  const navigate = useNavigate();
  useEffect(()=>{ api.get("/v1/maintenance-jobs").then((r)=>setJobs(r.data)); }, []);

  if (!jobs) return <div className="space-y-3">{[0,1,2].map(i=><Skeleton key={i} className="h-24 rounded-md"/>)}</div>;

  return (
    <div>
      <PageHeader title="Wartungsaufträge" subtitle="Standortbezogene Wartung & Prüfung · zentraler Einstiegspunkt · Fortschritt (offen / in Arbeit / erledigt)" />
      {jobs.length===0 && <Card className="rounded-md border p-8 text-center text-sm text-muted-foreground">Keine Aufträge. Plane eine Wartung über einen Standort.</Card>}
      <div className="space-y-3">
        {jobs.map((j)=>{ const p=j.progress; const pct=p.total?Math.round(p.erledigt/p.total*100):0;
          const types = [...new Set((j.assets_summary||[]).map((a)=>a.asset_type).filter(Boolean))];
          const names = (j.assets_summary||[]).map((a)=>a.kundenbezeichnung||a.name).filter(Boolean);
          return (
          <Card key={j.id} data-testid={`job-card-${j.id}`} onClick={()=>navigate(`/wartungsauftraege/${j.id}`)}
            className="group cursor-pointer rounded-md border p-4 transition-all hover:border-primary/40 hover:shadow-sm">
            <div className="flex items-center justify-between gap-4">
              <div className="flex min-w-0 items-center gap-3">
                <Wrench size={20} weight="duotone" className="shrink-0 text-primary"/>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-x-2 text-sm font-bold">
                    <span className="flex items-center gap-1"><Buildings size={13} weight="duotone"/>{j.site_name}</span>
                    {j.customer_name && <span className="text-muted-foreground">· {j.customer_name}</span>}
                  </div>
                  <div className="mt-0.5 flex items-center gap-2 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1"><User size={11}/>{j.monteur_name||"—"}</span>
                    <span>· {j.zeitraum?.start ? new Date(j.zeitraum.start).toLocaleDateString("de-DE") : "—"}</span>
                  </div>
                </div>
              </div>
              <div className="flex shrink-0 items-center gap-4">
                <div className="hidden w-40 sm:block">
                  <div className="mb-1 text-right text-xs text-muted-foreground">{p.erledigt}/{p.total}</div>
                  <div className="h-2 overflow-hidden rounded-full bg-muted"><div className="h-full rounded-full bg-emerald-500" style={{width:`${pct}%`}}/></div>
                </div>
                <Badge variant="outline" className={`rounded-md text-xs ${JOB_TONE[j.status]||""}`}>{j.status}</Badge>
                <CaretRight size={18} className="text-muted-foreground transition-transform group-hover:translate-x-0.5"/>
              </div>
            </div>
            {(types.length>0 || names.length>0) && (
              <div className="mt-3 flex flex-wrap items-center gap-1.5 border-t border-border pt-3">
                {types.map((t)=><Badge key={t} variant="outline" className="rounded-md text-[10px]">{t}</Badge>)}
                {names.length>0 && <span className="text-xs text-muted-foreground">{names.slice(0,6).join(" · ")}{names.length>6?" …":""}</span>}
              </div>
            )}
          </Card>
        );})}
      </div>
    </div>
  );
}
